import { __decorate } from "tslib";
import { Logger, LogLevel } from "@leavy/logger";
import { injectable } from "inversify";
const noop = () => undefined;
const log = console.log ?? noop;
const debug = console.debug ?? log;
const info = console.info ?? log;
const warn = console.warn ?? log;
const error = console.error ?? log;
const trace = console.trace ?? log;
/**
 * A browser implementation for `@leavy/logger`.
 * <br>The logs are output in the console.
 */
let ConsoleLogger = class ConsoleLogger extends Logger {
    log(logModel) {
        const { level, message, meta } = logModel;
        switch (level) {
            case LogLevel.None:
                break;
            case LogLevel.Fatal:
                error(`%c FATAL %c ${message}`, "font-weight: bold; color: white; border-radius: 10px; background-color: #EB3941;", "color: black;", meta);
                break;
            case LogLevel.Error:
                error(message, meta);
                break;
            case LogLevel.Warn:
                warn(message, meta);
                break;
            case LogLevel.Info:
                info(`%c INFO %c ${message}`, "font-weight: bold; color: white; border-radius: 10px; background-color: #4287f5;", "color: black;", meta);
                break;
            case LogLevel.Debug:
                debug(`%c DEBUG %c ${message}`, "font-weight: bold; color: #a1a3ad; border-radius: 10px; border: 1px solid #a1a3ad;", "color: black;", meta);
                break;
            case LogLevel.Trace:
                trace(`%c TRACE %c ${message}`, "font-weight: bold; color: #a1a3ad; border-radius: 10px; border: 1px solid #a1a3ad;", "color: black;", meta);
                break;
        }
    }
    close() {
        throw new Error("Operation not supported on ConsoleLogger");
    }
    createChild(meta) {
        throw new Error("Operation not supported on ConsoleLogger");
    }
};
ConsoleLogger = __decorate([
    injectable()
], ConsoleLogger);
export { ConsoleLogger };
export const DEFAULT_LOGGER = new ConsoleLogger();
//# sourceMappingURL=console.js.map